import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { withStyles, StyledComponentProps, CssBaseline, AppBar, Slide, Snackbar } from '@material-ui/core';
import { withRouter } from 'react-router';
import { IActions, actionCreator } from '../common/Auth0/store/actions/creators';
import { actionCreator as contactActions, IActions as IContactActions } from '../common/store/contacts/actions/creators';
import { actionCreator as chatActions, IActions as IChatActions } from '../scenes/chat/store/actions/creators';
import { IApplicationState } from '../store/ApplicationState';
import { connect } from 'react-redux';
import { layoutStyle } from './Layout.style';
import { LayoutRoutes } from '../common/navigation/Routes';
import { IMediaQueryProps, WithMediaQuery } from './withMediaQuery';
import { accessToken, useAuth0 } from '../common/Auth0/react-auth0-spa';
import { LeftDrawer } from './LeftDrawer';
import { TopBar } from './TopBar';
import { BottomBar } from './Footer/BottomBar';
import { IRouterAppProps } from '../common/interfaces/IRouterAppProps';
import { HandlerMessageReceived } from './HandlerMessageReceived';
import { Alert } from '@material-ui/lab';
import { notifActionCreator as notificationActions, INotificationActions as INotificationAction, INotificationActions } from '../common/store/notification/actions/creators';
import { INotificationState } from '../common/store/notification/state';
import { SignalRConnection } from '../common/SignalR/SignalRConnection';

interface IProps extends IActions, StyledComponentProps, IRouterAppProps, INotificationAction, IChatActions, IContactActions, IMediaQueryProps {
    newMessageReceived: boolean;
    saveNotification: INotificationState['saveNotification'];
    setSaveNotification: INotificationActions['setSaveNotification'];
}

const LayoutComp = (props: IProps) => {
    const [drawerOpen, setDrawerOpen] = useState(!props.smallScreen);
    const [currentMenuSelection, setCurrentMenuSelection] = useState(window.location.pathname.replace('/private/', ''));
    const { isAuthenticated, logout, loading, userRole, user, verifyRole } = useAuth0();
    const { classes, navigateTo, saveNotification } = props;

    const handleDrawerOpen = () => setDrawerOpen(true);
    const handleDrawerClose = () => setDrawerOpen(false);

    const logOut = () => {
        logout();
        handleMenuSelection("/login");
    }

    const handleMenuSelection = (path: string) => {

        // console.log("---------------------> handleMenuSelection, userRole", userRole)
        // console.log("---------------------> handleMenuSelection, isAuthenticated", isAuthenticated)
        // console.log("---------------------> handleMenuSelection, user", user)
        
        const role = verifyRole();
        
        // if (smallScreen || path === '/login') {
        if (role === 'admin') {
            let newMenuSection = path.replace('/private/', '');
            handleDrawerClose();
            // 
            if (currentMenuSelection !== newMenuSection) {
                if (newMenuSection === "Chat") {
                    props.restNewMessageReceivedStatus();
                }
                setCurrentMenuSelection(newMenuSection);
                navigateTo(path);
            }
        }
        else if (isAuthenticated && role !== 'admin') {
            navigateTo('/public');
        }
        else {
            navigateTo('/login');
        }
    }

    useEffect(() => {
        if (loading) {
            return;
        }
        if (isAuthenticated && userRole === 'admin') {
            // TODO SIGNALR SIGNAL-R REMEMBER TO ENABLE, REMEMBER
            SignalRConnection.initConnection(accessToken);
            SignalRConnection.OnUserConnected = props.userConnected;
            SignalRConnection.OnUserDisconnected = props.userDisconnected;
            SignalRConnection.OnJwtTokenExpired = () => logOut();
        }
    });

    useEffect(() => {
        // console.info("CHANGE USER ROLE TO : userRole", userRole)
        // console.info("CHANGE USER ROLE TO : isAuthenticated", isAuthenticated)
        // console.info("CHANGE USER ROLE TO : user", user)
        handleMenuSelection('/')

    }, [userRole]);

    const verifyCurrentSelection = (path: string) => {
        let pathSplitted = path.split('/');
        let menuSelection = pathSplitted[2] !== undefined ? pathSplitted[2] : currentMenuSelection;
        if (menuSelection !== currentMenuSelection) {
            setCurrentMenuSelection(menuSelection);
        }
    }

    const handleClose = (e, r) => {
        if (r === 'timeout') {
            props.setSaveNotification(undefined);
        }
    };

    // const handleOpen = () => {
    //     props.setSaveNotification(true);
    // };

    function TransitionRight(props) {
        return <Slide {...props} direction="right" />;
    }


    verifyCurrentSelection(props.location.pathname)
    // let path = props.location.pathname;
    // let pathSplitted = path.split('/');
    // let menuSelection = pathSplitted[2] !== undefined ? pathSplitted[2] : currentMenuSelection;
    return (
        <div className={classes.layoutRoot}>
            <CssBaseline />
            <AppBar
                //position="fixed"
                className={clsx(classes.appBar, {
                    //[classes.appBarShift]: drawerOpen,
                })}
            >
                <HandlerMessageReceived currentMenuSection={currentMenuSelection} />
                <TopBar classes={classes}
                    newMessageReceived={props.newMessageReceived}
                    restNewMessageReceivedStatus={props.restNewMessageReceivedStatus}
                    currentMenuSelection={currentMenuSelection}
                    handleDrawerOpen={handleDrawerOpen} />
                <LeftDrawer {...{ classes, drawerOpen, handleDrawerClose, handleMenuSelection, logOut }} />
            </AppBar>
            <main className={classes.main}>
                <div className={classes.layoutContent}>
                    <LayoutRoutes />
                </div>
            </main>
            <BottomBar classes={classes} />
            {/* <div className={props.classes.newMessageReceivedContainer}>
                {true && <Button style={{ backgroundColor: 'lime', padding: "2px", color: "#0a0a0a", margin: "0px" }} onClick={() => handleOpen()}>
                    Salvataggio OK
                </Button>}
            </div> */}
            <Snackbar
                open={!!saveNotification}
                onClose={handleClose}
                TransitionComponent={TransitionRight}
                key="snackbar_saved_key"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                autoHideDuration={2000}
            >
                <Alert
                    //onClose={handleClose}
                    severity={saveNotification?.result ? 'success' : 'error'}
                    style={saveNotification?.result
                        ? { backgroundColor: 'lime', color: '#3a3f53', width: '100%' }
                        : {}}>
                    {saveNotification?.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

const mapStateToProps = (state: IApplicationState, ownp: any) => ({ ...state.auth, ...ownp, newMessageReceived: state.chatmessages.newMessageReceived, saveNotification: state.notification.saveNotification });
const mapDispatchToProps = d => ({ ...actionCreator(d), ...contactActions(d), ...chatActions(d), ...notificationActions(d) });

export const Layout = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(layoutStyle)(WithMediaQuery(LayoutComp))));
